import React from 'react';
import Button from '@mui/material/Button';
import GoogleAutoComplete from './googleAutoComplete';
import { Grid, Typography } from '@mui/material';
import { getOrdinal } from 'src/helper';
import { ICONS } from 'src/assets/library';

const DynamicGoogleAutocompleteFields = ({
  coordinates,
  handlePlaceSelect,
  loading,
  addCoordinate,
  removeCoordinate,
  disabled,
}) => {
  function redirectToMap(lat, lng) {
    const link = `https://www.google.com/maps/dir/?api=1&&destination=${lat},${lng}`;
    window.open(link);
  }
  return (
    <div>
      {coordinates.map(({ lat, lng, address }, index) => (
        <div key={index} style={{ marginBottom: 10, marginTop: 10 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography color={'primary'} variant="body" my={1}>
              {getOrdinal(index + 1)} destination
            </Typography>
            <Grid
              sx={{
                backgroundColor: 'white',
                cursor: 'pointer',
                border: '1px solid #cccccc',
                p: '4px',
                borderRadius: '5px',
                '&:hover': {
                  border: '1px solid #e0e4e8',
                },
              }}
              onClick={() => redirectToMap(lat, lng)}
            >
              {ICONS.pinImage}
            </Grid>
          </div>
          <GoogleAutoComplete
            key={index}
            selectProps={{
              isDisabled: loading || disabled,
              placeholder: `${getOrdinal(index + 1)} destination`,
              onChange: (selected) => {
                handlePlaceSelect(index, selected);
              },
              value: address !== null && { label: address, value: { place_id: '' } },
            }}
          />
          {index > 1 && (
            <span
              style={{ fontSize: '12px', cursor: 'pointer', color: 'blue' }}
              onClick={() => removeCoordinate(index)}
            >
              Remove Destination
            </span>
          )}
        </div>
      ))}
      {!disabled && (
        <Button variant="contained" color="primary" size="small" onClick={addCoordinate} sx={{ marginY: 2 }}>
          Add Destination
        </Button>
      )}
    </div>
  );
};

export default DynamicGoogleAutocompleteFields;
